// import store from "@/state/store";

export default [
  // {
  //   path: "/",
  //   name: "root",
  //   beforeEnter: (to, from, next) => {
  //     const loggedIn = localStorage.getItem("jwt");

  //     if (loggedIn) {
  //       next({ name: "default" });
  //     } else {
  //       next({ name: "landing" });
  //     }
  //   },
  // },
  {
    path: "/",
    name: "landing",
    meta: { title: "Landing", authRequired: false },
    component: () => import("../views/landing/index"),
  },
  {
    path: "/apps-guide",
    name: "apps-guide",
    meta: { title: "Panduan Aplikasi", authRequired: false },
    component: () => import("../views/guides/apps"),
  },
  {
    path: "/news",
    name: "news",
    meta: { title: "Berita Saka Agung Abadi", authRequired: false },
    component: () => import("../views/news/index"),
  },
  {
    path: "/news/add",
    name: "news-add",
    meta: { title: "Tambah Berita", authRequired: false },
    component: () => import("../views/news/add"),
  },
  {
    path: "/news-detail",
    name: "news-detail",
    meta: { title: "Detail Berita", authRequired: false },
    component: () => import("../views/news/detail"),
  },
  {
    path: "/login",
    name: "login",
    meta: { title: "Login", authRequired: false },
    component: () => import("../views/auth/login"),
  },
];
